import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useSessionStorage } from 'usehooks-ts';
import { SORT_KEY, SORT_INITIALIZED_KEY } from '../../utils/searchSortStorage';

export default function SearchResultsSorting({ sorting }: { sorting: any }) {
  const [sort, setSort] = useSessionStorage(SORT_KEY, sorting.default);
  const [sortInitialized, setSortInitialized] = useSessionStorage(SORT_INITIALIZED_KEY, false);

  React.useEffect(() => {
    if (!sortInitialized && sorting?.default) {
      setSort(sorting.default);
      setSortInitialized(true);
    }
  }, [setSort, setSortInitialized, sortInitialized, sorting?.default]);

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Typography variant="body2" component="p">
        Sort by:
      </Typography>
      <Select
        size="small"
        variant="standard"
        sx={{ fontSize: 16 }}
        value={sort}
        onChange={(e) => setSort(e.target.value)}>
        {sorting.options.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            <Typography variant="body2" component="p">
              {option.label}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
